import { useCallback } from 'react';

import { ApplicationStarButton } from '@/components/applications/ApplicationStarButton';
import { useApplicationStar } from '@/hooks/useApplicationStar';
import type { Application } from '@/types';

type Props = {
  app: Application;
  companyId: string | undefined;
  userId: string | undefined;
  starLabel: string;
  unstarLabel: string;
};

export function ApplicationStarCell({
  app,
  companyId,
  userId,
  starLabel,
  unstarLabel,
}: Props) {
  const { toggleStar, isStarred, isBusy } = useApplicationStar(companyId, userId);

  const handleToggle = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    void toggleStar(app);
  }, [app, toggleStar]);

  const starred = isStarred(app);

  return (
    <ApplicationStarButton
      starred={starred}
      busy={isBusy(app.id)}
      disabled={!companyId || !userId}
      ariaLabel={starred ? unstarLabel : starLabel}
      onToggle={handleToggle}
    />
  );
}
